import { validationTypes } from "../../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";
import TitleWrapper from "../../../../../components/ui/titlewrapper/TitleWrapper";

const initState = {
    IsZoomRegistrationApproval: 'meeting',
    zoomAccountId: null,
    zoomAccountHolderName: ''
};

export const ZoomAccountFormData = {
    name: "ZoomAccountFormData",
    initialState: initState,
    section: [
        {
            title: "Select Zoom Account Section",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },

            wrapperTemplate: <TitleWrapper title="Select Zoom Account" />,

            fields: [
                {
                    id: "IsZoomRegistrationApproval",
                    label: "Registration Approval",
                    Field_Name: "Registration Approval",
                    fieldType: FormFieldTypes.RADIOBUTTON,
                    dataField: "IsZoomRegistrationApproval",
                    fieldSetting: {
                        allowSpace: true,
                        options: [
                            { value: "meeting", label: "Meeting" },
                            { value: "webinar", label: "Webinar" },
                            { value: "others", label: "Others" },
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 radioStyle col-md-12 ",
                    },
                },
                {
                    id: "zoomAccountId",
                    label: "Zoom Meeting Id",
                    Field_Name: "Zoom Meeting Id",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "zoomAccountId",
                    fieldSetting: {
                        placeholder: "Please Enter Meeting Id",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0 mb-2 mt-2",
                    },
                },
                {
                    id: "zoomAccountHolderName",
                    label: "Zoom Account",
                    Field_Name: "Zoom Account",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "zoomAccountHolderName",
                    fieldSetting: {
                        placeholder: "Select",
                        allowSpace: true,
                        options: [

                        ],
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0 mt-2",
                    },
                },
            ],
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};
